module.exports = __webpack_public_path__ + "img/blackred.58d7d124.png";